import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/shared/item_box';
import { Link } from 'react-router-dom';


function BalancoScreen() {
    return (
        <Fragment>
            <Head titulo="Balanços do Município de Macuco" />
            <Header />
            <Container>
                <ItemBox
                    titulo={"Balanços Orçamentários"}
                    texto={<Fragment>Demonstrativo contábil em que se confrontam, num dado momento, as receitas e despesas previstas na lei orçamentária com as realizadas. A partir da comparação entre o previsto e o realizado é possível constatar a ocorrência de superávit, déficit ou equilíbrio orçamentário.<br/><br/></Fragment>}
                    link={"balanco/orcamentario"}
                />
                <ItemBox
                    titulo={"Balanços Financeiros"}
                    texto={<Fragment>Demonstrativo contábil em que se confrontam num dado momento, as receitas e despesas orçamentárias, bem como os recebimentos e os pagamentos de natureza extra-orçamentária, conjugados com os saldos em espécie provenientes do exercício anterior, e os que se transferem para o exercício seguinte. A estrutura do Balanço Financeiro permite verificar, no confronto entre receita e despesa, o resultado financeiro do exercício, bem como o saldo em espécie que se transfere para o exercício seguinte, saldo esse que pode ser positivo (superávit) ou zero (equilíbrio).<br/><br/></Fragment>}
                    link={"balanco/financeiro"}
                />
                <ItemBox
                    titulo={"Balanços Patrimoniais"}
                    texto={<Fragment>O balanço patrimonial é a demonstração contábil que evidencia, qualitativa e quantitativamente, a situação patrimonial da entidade pública, por meio de contas representativas do patrimônio público, além das contas de compensação.<br/><br/></Fragment>}
                    link={"balanco/patrimonial"}
                />
                <Link to={"/"}>
                    <Button variant='danger' type='button'>Voltar</Button>
                </Link>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default BalancoScreen;